import { render, staticRenderFns } from "./Files.vue?vue&type=template&id=6cb9d16c&scoped=true&"
import script from "./Files.vue?vue&type=script&lang=js&"
export * from "./Files.vue?vue&type=script&lang=js&"
import style0 from "./Files.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Files.vue?vue&type=style&index=1&id=6cb9d16c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!//////node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9d16c",
  null
  
)

export default component.exports